import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import type { ReactElement } from "react";

import { SessionProvider, useSession } from "./session";
import IndexPage from "./pages/IndexPage";
import DocPage from "./pages/DocPage";
import EditPage from "./pages/EditPage";
import LoginPage from "./pages/LoginPage";

function Gate({ children }: { children: ReactElement }) {
  const { user, loading } = useSession();
  const location = useLocation();

  if (loading) {
    return (
      <div className="shell">
        <div className="notice">Checking your session…</div>
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}

export default function App() {
  return (
    <SessionProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <Gate>
              <IndexPage />
            </Gate>
          }
        />
        <Route
          path="/d/:slug"
          element={
            <Gate>
              <DocPage />
            </Gate>
          }
        />
        <Route
          path="/d/:slug/edit"
          element={
            <Gate>
              <EditPage />
            </Gate>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </SessionProvider>
  );
}
